import { render, staticRenderFns } from "./AttachmentDocument.vue?vue&type=template&id=5fd4c9ec&scoped=true"
import script from "./AttachmentDocument.vue?vue&type=script&lang=js"
export * from "./AttachmentDocument.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDocument.vue?vue&type=style&index=0&id=5fd4c9ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4c9ec",
  null
  
)

export default component.exports